<template>
    <div class="index">
        <div class="top">
            <!-- <img src="../../assets/imgs/travel-diary-bg.png" alt=""> -->
            <div class="title">Travel Diary</div>
            <!-- 没用 -->
        </div>
        <div class="message">
            <div class="w-1200">
                <div class="title" v-appear-animation="{ appearClass: 'animate-scale' }">Travel Diary</div>
                <div class="lists">
                    <div class="left-list">
                        <div class="list" v-appear-animation="{ appearClass: 'animate-fade-out' }" v-for="value in 5"
                            :key="value" @click="toDetailFn">
                            <div class="img">
                                <img src="https://img1.baidu.com/it/u=659202549,4057406052&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=586"
                                    alt="">
                            </div>
                            <div class="right">
                                <div class="list-title">Australia Top Star is Ruby</div>
                                <div class="text u-line-3">
                                    这个周末，Ruby在成都太古里等你！快来打卡我的裸眼3D大屏👀逛逛澳大利亚旅游局的品牌官方快闪店吧📷
                                    带话题#来澳大利亚道一声你好#发布你的活动打卡体验，我会随机闪现评论区“翻牌”，送出限量版Ruby玩偶哦！
                                </div>
                                <div class="people-info">
                                    <div class="people-img">
                                        <img src="https://img0.baidu.com/it/u=1055023845,1912019569&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=500"
                                            alt="">
                                    </div>
                                    <div class="author">
                                        落日晚风
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-list">
                        <div class="right-title">Related attractions</div>
                        <div class="list" v-appear-animation="{ appearClass: 'animate-slide-in-right' }"
                            v-for="value in 4" @click="toDetailFn" :key="value">
                            <div class="img">
                                <img src="https://jaxawpmpsz.sctt.net/Product/394561/1683783711876.png?x-oss-process=image/resize,m_lfit,w_400,h_300/format,webp"
                                    alt="">
                            </div>
                            <div class="right">
                                <div class="list-title">【Sydney Zoo】白天门票 (Blacktown附近)（有效期扫码票</div>

                                <div class="money">
                                    <span>AUD 39</span><b>起</b>
                                    <i>AUD 42</i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize3" background border
                    layout="prev, pager, next" :total="1000" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            currentPage: 5,
            pageSize3: 100,
     
        }
    },
    mounted() {

    },
    methods: {
        toDetailFn() {
            this.$router.push('/en/diaryDetail')
        },
        handleSizeChange(val) {
            console.log(`${val} items per page`);
        },
        handleCurrentChange(val) {
            console.log(`current page: ${val}`);
        },
    },
    beforeDestroy() {
    },
}
</script>

<style lang="less" scoped>
.index {
    width: 100vw;
    position: relative;
    user-select: none;
    background-color: #f0f0f0;

    .el-pagination {
        margin: 50px auto 120px;
        display: flex;
        justify-self: center;
    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ec0b29;
    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #ec0b29;
    }

    .top {
        width: 100vw;
        height: 650px;
        position: relative;
        overflow: hidden;

        &::after {
            content: '';
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 200px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
            z-index: 1;
        }

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 80px;
            font-weight: 700;
            color: #fff;
            z-index: 3;
            text-shadow: 3px 3px 5px #002c2d;
            letter-spacing: 2px;
        }

        .subtitle {
            position: absolute;
            top: 60%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 80px;
            font-weight: 700;
            color: #fff;
        }


        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover img {
            transform: scale(1.1);
        }
    }

    .breadcrumb {
        margin: 40px auto;
        max-width: 1200px;
    }


    .message {
        padding: 80px 0 100px;

        .w-1200 {
            max-width: 1200px;
            margin: 0 auto;
        }

        .lists {
            display: flex;
        }


        .right-list {
            width: 30%;
            border-left: 1px solid #cccccc67;
            margin-left: 20px;
            padding-left: 20px;
            box-sizing: border-box;

            .right-title {
                font-size: 18px;
                font-weight: 500;
                color: #016b6d;
                color: #ec0b29;
                margin-bottom: 15px;
                padding-bottom: 5px;
            }

            .list {
                background-color: #fff;
                margin-bottom: 20px;
                padding: 15px;
                box-sizing: border-box;
                border-radius: 6px;
                transition: .3s all;
                cursor: pointer;

                &:hover {
                    transform: scale(1.05);
                    background-color: #ec0b29;

                    // background: linear-gradient(-125deg, #90d0e6, #016a6c);

                    .list-title {
                        color: #fff;
                    }

                    .money {
                        color: #eee;

                        span {
                            color: #fff;
                        }
                    }
                }

                .img {
                    width: 100%;
                    height: 180px;
                    overflow: hidden;
                    border-radius: 6px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .list-title {
                    padding: 10px 0 0;
                    font-size: 16px;
                    font-weight: 500;
                    color: #333;
                    transition: .3s all;
                }

                .money {
                    padding-top: 10px;
                    color: #666;
                    font-size: 14px;
                    transition: .3s all;

                    span {
                        transition: .3s all;
                        color: #ec0b29;
                        font-weight: 500;
                        font-size: 20px;
                        margin-right: 3px;
                    }

                    i {
                        font-style: normal;
                        margin-left: 10px;
                        text-decoration-line: line-through;
                    }
                }
            }
        }

        .title {
            font-size: 40px;
            font-weight: 700;
            text-align: center;
            margin-bottom: 90px;
            margin-top: 40px;
        }

        .left-list {
            width: 70%;

            .list {
                cursor: pointer;
                display: flex;
                margin-bottom: 40px;
                padding-bottom: 40px;
                background-color: #fff;
                padding: 15px;
                box-sizing: border-box;
                position: relative;
                border-radius: 5px;
                transition: .3s all;

                &::after {
                    content: '';
                    left: 0;
                    bottom: -20px;
                    width: 100%;
                    height: 1px;
                    position: absolute;
                    background-color: #cccccc67;
                }

                &:nth-last-of-type(1)::after {
                    content: none;
                }

                &:hover {
                    box-shadow: 0 8px 7px 0 rgba(0, 0, 0, 0.1), 0 6px 10px 0 rgba(0, 0, 0, 0.1);

                    .list-title,
                    .text {
                        color: #ec0b29;
                    }
                }

                .right {
                    flex: 1;
                    margin-left: 20px;
                }

                .img {
                    width: 350px;
                    height: 200px;
                    overflow: hidden;
                    flex-shrink: 0;
                    border-radius: 6px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .right {
                    flex: 1;
                    margin-left: 20px;
                }

                .people-info {
                    display: flex;
                    align-items: center;
                }

                .people-img {
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    border-radius: 50%;
                    margin-right: 10px;
                }

                .people-img img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .list-title {
                    font-size: 20px;
                    font-weight: 700;
                    color: #000;
                    margin-bottom: 14px;
                    transition: .3s all;
                    padding-top: 10px;
                }

                .text {
                    color: #666;
                    font-size: 16px;
                    line-height: 30px;
                    transition: .3s all;
                    margin-bottom: 10px;
                }
            }
        }
    }


}
</style>



// WEBPACK FOOTER //
// src/views/en/diary.vue